import { LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Tooele County Portal": {
    parameters: {
      linkUrls: ["https://tooelecounty.tieriiportal.aristatek.com/"],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.UT.TOOELE_COUNTY,
          name: "Tooele County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "UT",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Utah County Portal": {
    parameters: {
      linkUrls: ["https://utahcounty.tieriiportal.aristatek.com/"],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.UT.UTAH_COUNTY,
          name: "Utah County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "UT",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Utah Tier2 Submit": {
    parameters: {
      linkUrls: [
        "https://login.dts.utah.gov/sso/XUI/?goto=https%3A%2F%2Ftier2.deq.utah.gov%2F#login/",
      ],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Tier2 Submit",
    state: "UT",
  },
  "Davis County Portal": {
    parameters: {
      linkUrls: ["https://www.daviscountyutah.gov/emergency-management/lepc-reporting"],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.UT.DAVIS_COUNTY,
          name: "Davis County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "UT",
    dependsOn: ["Tier2SubmitValidation"],
  },
  "Salt Lake City Portal": {
    parameters: {
      linkUrls: [
        "https://fulfillmentguide.helpkit.so/chemicals/6NmwbK2GNFS9Az6DhF7Xez/utah/hqk677yeod3p7DSTqDvjpm#local-nuances",
      ],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.UT.SALT_LAKE_CITY,
          name: "Salt Lake County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "UT",
    dependsOn: ["Tier2SubmitValidation"],
  },
};
